export default "__VITE_PUBLIC_ASSET__91f93dd1__"